import get from "lodash/get";

export function replaceValues(txt, obj) {
  if (!txt) return "";
  return txt.replace(/{{(.*?)}}/g, (m, key) => get(obj, key) || "");
}
